/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/4/2022.
 */

import React from 'react'
import {withRouter} from 'react-router'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import * as FaultActions from '../FaultActions'
import * as SecurityActions from '../../security/SecurityActions'
import {injectIntl, FormattedMessage} from 'react-intl';
import {Button, Table, Radio, Notification} from '@scuf/common';
import {isClosedState} from "../common/FaultsConst";
import {userHasActivity} from "../../security/SecurityUtils";
import {ACTIVITY_TYPES} from "../../security/SecurityConst";
import {verifyAirtimeException} from "../../utils/Helpers";


class Verification extends React.Component {
    constructor(props) {
        super(props)
        this.setObservationValue = this.setObservationValue.bind(this)
    }

    setObservationValue(id, value) {
        this.props.FaultActions.setVerificationObservation(id, value);
    }

    componentDidMount() {
        const me = this
        this.props.FaultActions.fetchVerificationObservations(this.props.fault.assetId, this.props.fault.faultId,
            userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY)).then(() => {
            const {fault} = me.props
            if (fault.verificationObservations.length === 0) {
                me.props.nextButtonClick();
            }
        }).catch(ex => {
            verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
        });
    }

    getObservationsRows(observations) {
        if (observations.length === 0) {
            return (<Table.Row>
                <Table.Cell colSpan="3">
                    <FormattedMessage id="fault.troubleshoot.verification.empty"/>
                </Table.Cell>
            </Table.Row>)
        }
        return observations.map((o, i) => {
            return (
                <React.Fragment key={o.id}>
                    <Table.Row className={this.getRowClass("extra-row mobile only", i)}>
                        <Table.Cell colSpan="3">
                            {o.description}
                        </Table.Cell>
                    </Table.Row>
                    <Table.Row className={this.getRowClass("", i)}>
                        <Table.Cell className="computer only">
                            {o.description}
                        </Table.Cell>
                        <Table.Cell textAlign="center">
                            {this.getObservationRadioButton(o.id, 'PRESENT', o.state)}
                        </Table.Cell>
                        <Table.Cell textAlign="center">
                            {this.getObservationRadioButton(o.id, 'ABSENT', o.state)}
                        </Table.Cell>
                    </Table.Row>
                </React.Fragment>
            )
        })
    }

    getRowClass(className, index) {
        return className + ' ' + (index % 2 === 0 ? 'even' : 'odd')
    }

    getObservationRadioButton(id, value, currentValue) {
        return (
            <Radio
                name={'observation-'+id}
                checked={currentValue === value}
                onChange={() => this.setObservationValue(id, value)}
                disabled={this.props.fault.readOnly}
            />
        )
    }

    render() {
        const {intl, fault} = this.props

        const rows = this.getObservationsRows(fault.verificationObservations);

        let nextButton = '';
        if (!fault.readOnly || isClosedState(fault.details.faultConditionState)) {
            nextButton = <Button content={intl.formatMessage({id: "fault.troubleshoot.button.summary"})} icon="caret-right" iconPosition="right" onClick={this.props.nextButtonClick}/>
        }

        let previousButton = '';
        if (fault.readOnly) {
            previousButton = <Button content={intl.formatMessage({id: "fault.troubleshoot.button.troubleshoot"})} icon="caret-left" iconPosition="left" onClick={this.props.previousButtonClick}/>
        }

        return (
            <div id="validation-step">
            {
                (fault.verificationObservations && fault.verificationObservations.length !== 0) &&
                <div>
                    <Notification
                        className="read-only-info"
                        hasIcon={true}
                        severity="information">
                        <FormattedMessage id="fault.troubleshoot.verification.review"/>
                    </Notification>
                </div>
            }
                <Table className="unstackable">
                    <Table.Header>
                        <Table.HeaderCell content={intl.formatMessage({id: "fault.troubleshoot.table.header.observation"})} className="computer only"/>
                        <Table.HeaderCell content={intl.formatMessage({id: "fault.troubleshoot.table.header.present"})} textAlign="center" className="radio-cell"/>
                        <Table.HeaderCell content={intl.formatMessage({id: "fault.troubleshoot.table.header.absent"})} textAlign="center" className="radio-cell"/>
                    </Table.Header>
                    <Table.Body>
                        {rows}
                    </Table.Body>
                </Table>

                <div className="button-panel">
                    <div className="left">
                        {previousButton}
                    </div>
                    <div className="right">
                        {nextButton}
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        fault: state.fault,
        userProfile: state.security.userProfile,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        FaultActions: bindActionCreators(FaultActions, dispatch),
        SecurityActions: bindActionCreators(SecurityActions, dispatch),
    }
}


export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(Verification)))